import { render, staticRenderFns } from "./MapBoxMarker.vue?vue&type=template&id=64f62944"
import script from "./MapBoxMarker.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapBoxMarker.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports